export default __webpack_public_path__ + "static/media/paper_plane.e7b69ef0.svg";